import { render, staticRenderFns } from "./newBuildProcess.vue?vue&type=template&id=3024cd26&scoped=true&"
import script from "./newBuildProcess.vue?vue&type=script&lang=js&"
export * from "./newBuildProcess.vue?vue&type=script&lang=js&"
import style0 from "./newBuildProcess.vue?vue&type=style&index=0&id=3024cd26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3024cd26",
  null
  
)

export default component.exports